export default __webpack_public_path__ + "static/media/tab04_title02.fb177d8a.png";